import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useCurrentClient } from "hooks/api/use-clients";
import { CurrentCampaignProvider, useCampaign } from "hooks/api/use-campaigns";
import { CampaignJobPollingProvider } from "hooks/campaign-job-polling-provider";

import { Route } from "utilities/app-routes";

const CampaignProvider = ({
  children,
  currentCampaignId,
}: React.PropsWithChildren<{ currentCampaignId?: string }>) => {
  const { campaignId } = useParams<{ campaignId: string }>();
  const navigate = useNavigate();
  const client = useCurrentClient();

  const currCampaignId = campaignId || currentCampaignId;
  const { data: campaign, isError } = useCampaign({
    clientId: client.id,
    id: currCampaignId,
  });

  useEffect(() => {
    if (isError) {
      navigate(Route.notFound);
    }
  }, [isError, navigate]);

  const shouldRenderChildren = campaign && campaign.id === currCampaignId;

  return shouldRenderChildren ? (
    <CurrentCampaignProvider campaign={campaign}>
      <CampaignJobPollingProvider>{children}</CampaignJobPollingProvider>
    </CurrentCampaignProvider>
  ) : null;
};

export default CampaignProvider;
